import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { API_HOST } from 'environments/environment';
import { take } from 'rxjs';
import { SnackbarService } from '../../services/snackbar.service';
import { APIResponse } from 'fakturnia-shared';

@Component({
  selector: 'log-in-with-google',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './log-in-with-google.component.html',
  styleUrl: './log-in-with-google.component.scss'
})
export class LogInWithGoogleComponent {

  public isLoading = false;

  constructor(
    private _httpClient: HttpClient,
    private _snackbarService: SnackbarService
  ) { }

  public loginWithGoogle() {
    if (this.isLoading) return;
    
    this.isLoading = true;

    this._httpClient.post<APIResponse>(API_HOST + 'auth/google', {})
      .pipe(take(1))
      .subscribe({
        next: (response: APIResponse) => {
          if (!response.success || !response.data?.url) {
            this._snackbarService.showSnackBar(
              'Nie udało się przetworzyć Twojego żądania',
              'error',
              4000
            );
            this.isLoading = false;
            return;
          }

          // Przekieruj do Google OAuth
          window.location.href = response.data.url;
        },
        error: () => {
          this._snackbarService.showSnackBar(
            'Wystąpił błąd podczas logowania',
            'error',
            4000
          );
          this.isLoading = false;
        }
      });
  }
}
